import React from "react";
import {Box, IconButton, Typography} from "@mui/material";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import ListItemReversedTextView from "../../../../../common/components/ListItemReversedTextView";
import {Word} from "../../../../../common/types/words";
import {useConjugation} from "../../../../inflections/hooks/useConjugation";

export interface InfoHeaderViewProps {
    language: string;
    word: Word;
    audio: HTMLAudioElement | null;
    showPlaybackButton: boolean;
    onPlayAudio: (audio: HTMLAudioElement | null) => void;
}

export default function InfoHeaderView({language, word, audio, showPlaybackButton, onPlayAudio}: InfoHeaderViewProps) {

    const {posWithTagging} = useConjugation({word, language});

    return (
        <Box sx={{width: "100%", borderBottom: 1, borderColor: "divider"}}>
            <Box sx={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                <Box sx={{flexGrow: 1}}>
                    <ListItemReversedTextView title={language}
                                              divider={false}
                                              content={(
                                                  <Box sx={{display: "flex", alignItems: "center", justifyContent: "flex-start"}}>
                                                      {showPlaybackButton && (
                                                          <IconButton size="small"
                                                                      title={"Play"}
                                                                      edge={"start"}
                                                                      onClick={() => onPlayAudio(audio)}
                                                          >
                                                              <VolumeUpIcon fontSize={"small"} sx={{color: audio ? "black" : "gray"}}/>
                                                          </IconButton>
                                                      )}
                                                      {word.lemma}
                                                  </Box>
                                              )}/>
                </Box>
                {!!word.resources?.image && (
                    <Box component="img"
                         src={word.resources.image}
                         alt={word.lemma}
                         sx={{height: 60, width: 60, objectFit: "cover", flexShrink: 0, borderRadius: 1, mr: 2}}
                    />
                )}
            </Box>
            {!!posWithTagging && (
                <Typography variant="body2" color="textSecondary" sx={{px: 2, pb: 1, mt: -1}}>
                    {posWithTagging}
                </Typography>
            )}
        </Box>
    );
}
